import { Vue } from 'vue-property-decorator';
import {VNode} from 'vue';

import { getCardType, validateCard, clearCard } from './creditCardValidate';

interface SlotsInterface { [key: string]: VNode[] | undefined; }

const prepareSlots = (
    vm: typeof Vue.prototype,
    $createElement: typeof Vue.prototype.$createElement,
    slotsVNode: SlotsInterface | VNode[] | undefined,
): any => {
    const slots: VNode[] = slotsVNode || vm.$slots.default;
    try {
        const replaceVNodeToIntegrationComponent = (vn: any, index: number) => {
            if (vn.data && vn.data.key && vm.Integration.fields[vn.data.key]) {
                const component = vn.data.key;
                const attrs: { id?: string } = {};
                // @ts-ignore
                if (slots[index].data.attrs && slots[index].data.attrs.id) {
                    // @ts-ignore
                    attrs.id = slots[index].data.attrs.id;
                }

                vm.countCardElements(component);

                slots[index] = $createElement(vm.Integration.fields[component], {
                    attrs: {
                        ...attrs,
                    },
                    ref: component,
                    on: {
                       serialized(data: any) {
                           vm.$set(vm.form, component, data);
                       },
                        error() {
                           vm.failed = true;
                        },
                        valid(data: boolean) {
                           vm.$emit('action', {
                               field: component,
                               valid: data,
                           });

                           if (data) {
                               const chooseComponent = component === 'expiry'
                                       ? 'cvc'
                                       : false;
                               if (chooseComponent && vm.$refs[chooseComponent]) {
                                   vm.$refs[chooseComponent].toFocus();
                               }
                           }
                        },
                        loading(data) {
                            if (!data) {
                               vm.loadingCounter += 1;
                            }
                        },
                    },
                    props: {
                        autocomplete: vm.Integration.autocomplete,
                        integrationData: vm.Integration.integrationFields,
                        integrationStyles: vm.Integration.integrationStyles[+vm.styleVariant],
                        integrationCommonStyles: vm.Integration.integrationCommonStyles[+vm.styleVariant],
                    },
                });
            } else if (slots[index].children) {
                prepareSlots(vm, $createElement, slots[index].children);
            }
        };

        slots.forEach((vn, index) => {
            replaceVNodeToIntegrationComponent(vn, index);
        });
    } catch (e) {
        vm.failed = true;
        // tslint:disable-next-line
        console.error(e);
    }
};

const hardCodeBrand = (brandCome: string) => {
    let brand = brandCome ? brandCome.toLowerCase() : brandCome;
    const rightBrandsHardCode = {
        mastercard: 'master',
        discover: 'Discover',
        dinersclub: 'diners',
        unionpay: 'union_pay',
        hipercard: 'hiper',
        dankort: 'dan',
        visaelectron: 'visa',
        eurocard: 'Eurocard',
    };
    if (rightBrandsHardCode[brand]) {
        brand = rightBrandsHardCode[brand];
    }
    return brand;
};

export {
    prepareSlots,
    hardCodeBrand,
    getCardType,
    validateCard,
    clearCard,
};
